export enum InvoiceType {
    Unknown = 'Uknown',
    Income = 'Income',
    Expenses = 'Expenses',
    InternalIncome = 'InternalIncome',
}
